import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { useLocation, useParams } from "react-router-dom";
import { API_BASE_URL } from "../../../Apicongfig";
import axios from "axios";
import ErrorBoundary from "../../../Utils/ErrorBoundary";
import { formatDate, formatTime } from "../GetMeeting/Helpers/functionHelper";

const StepCounterContext = createContext();

export const useStepCounterContext = () => {
  const context = useContext(StepCounterContext);
  if (!context) {
    throw new Error(
      "useStepCounterContext must be used within a HeaderTitleProvider"
    );
  }
  return context;
};

export const StepCounterContextProvider = ({ children }) => {
  //centralized states for count down timer.
  const { id,step_Id } = useParams();
  const [meetingData, setMeetingData] = useState(null);
  const [loading,setLoading] = useState(false)
  const [activeStepIndex, setActiveStepIndex] = useState(0);
  const [savedTime, setSavedTime] = useState(0);
  const [negativeTimes, setNegativeTimes] = useState(Array().fill(0));
  const [selectedStep, setSelectedStep] = useState(null);

  const [stepDelay, setStepDelay] = useState(null); // New state for step delay
  const [nextStepTrigger, setNextStepTrigger] = useState(0);
  const [previousStepTrigger, setPreviousStepTrigger] = useState(0);

  const location = useLocation();

  useEffect(() => {
    if(!location.pathname?.includes("/act%C4%ABon-play/"))return
    if (meetingData && meetingData?.steps && meetingData?.steps[activeStepIndex]?.step_status === "in_progress") {
      if(meetingData?.steps[activeStepIndex]?.delay === null) return
      const sendCurrentTime = async () => {
        const inProgressStep = meetingData?.steps[activeStepIndex];
        const inProgressStepId = inProgressStep?.id;

        // Exit if there's no in-progress step
        if (!inProgressStepId) return;

        const currentTime = new Date();
        // Get the user's timezone
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // Convert the current time to the user's timezone
        const options = { timeZone: userTimeZone };
        const timeInUserZone = new Date(
          currentTime.toLocaleString("en-US", options)
        );

        // Format time
        const hours = timeInUserZone.getHours();
        const minutes = timeInUserZone.getMinutes();
        const seconds = timeInUserZone.getSeconds();
        const ampm = hours >= 12 ? "PM" : "AM";
        const formattedHours = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
        const formattedSeconds = seconds < 10 ? "0" + seconds : seconds;
        const formattedTime = `${formattedHours}:${formattedMinutes}:${formattedSeconds} ${ampm}`;

        // Format date
        const year = timeInUserZone.getFullYear();
        const month = (timeInUserZone.getMonth() + 1)
          .toString()
          .padStart(2, "0");
        const day = timeInUserZone.getDate().toString().padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        const payload = {
          delay_seconds: 30,
          step_id: inProgressStepId,
          current_time: formattedTime,
          current_date: formattedDate,
          timezone:userTimeZone
        };

        try {
          const response = await axios.post(
            `${API_BASE_URL}/update-delay`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
              },
            }
          );

          if (response?.status) {
            const delay = response?.data?.data;
            setStepDelay(delay);
          }
        } catch (error) {
          console.log("error while sending current time", error);
        }
      };
      if (
        meetingData?.steps[activeStepIndex]?.delay !== null ||
        negativeTimes[activeStepIndex] > 0
      ) {
        sendCurrentTime();
      }

      let timeoutId;
      let intervalId;

      // Set the timeout to start the interval after 1 minute
      timeoutId = setTimeout(() => {
        intervalId = setInterval(() => {
          if (
            meetingData?.steps[activeStepIndex]?.delay !== null ||
            negativeTimes[activeStepIndex] > 0
          ) {
            sendCurrentTime();
          }
        }, 30000); // Executes every 30 seconds
      }, 30000); // Initial delay of 1 minute
      //   }, 30000); // Executes every 30 seconds
      // }, 30000); // Initial delay of 1 minute

      // Cleanup function
      return () => {
        clearTimeout(timeoutId); // Clear the timeout
        clearInterval(intervalId); // Clear the interval
      };
    }
  }, [location.pathname,meetingData, activeStepIndex, negativeTimes]);

  useEffect(() => {
    if(!location?.pathname?.includes("/act%C4%ABon-play/"))return



    const getMeetingByID = async (meetingID) => {
      setLoading(true)
      const currentTime = new Date();
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      const options = { timeZone: userTimeZone };
      const timeInUserZone = new Date(
        currentTime.toLocaleString("en-US", options)
      );

      const formattedTime = formatTime(timeInUserZone);
      const formattedDate = formatDate(timeInUserZone);

      try {
        const response = await axios.get(
          `${API_BASE_URL}/meetings/${meetingID}?current_time=${formattedTime}&current_date=${formattedDate}&timezone=${userTimeZone}&do_continue_change_cal=true`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        if (response.status) {
          // console.log("response from getMeeting by ID ->", response?.data?.data);
          setMeetingData(response?.data?.data);
          // Find the active step index based on step_id from params if available
        let activeIndex = 0; // default to first step
        
        if (step_Id) {
          // Find the step with matching ID
          const stepIndex = response.data?.data?.steps.findIndex(
            step => parseInt(step.id) === parseInt(step_Id)
          );
          if (stepIndex !== -1) {
            activeIndex = stepIndex;
          }
        } else {
          // Fallback to finding first in_progress step if no step_id in params
          const inProgressIndex = response.data?.data?.steps.findIndex(
            step => step?.step_status === "in_progress"
          );
          if (inProgressIndex !== -1) {
            activeIndex = inProgressIndex;
          }
        }
        
        setActiveStepIndex(activeIndex);

          const negativeTimes = response?.data?.data?.steps?.map((step) => {
            if (step.negative_time) return parseInt(step.negative_time);
          });
          // console.log("negativeTimes", negativeTimes);
          setNegativeTimes(negativeTimes);
          return response;
        }
      } catch (error) {
        // console.log("error", error);
        return error.response;
      }finally{
      setLoading(false)

      }
    };
    if(id){
      getMeetingByID(id);
    }
  }, [location?.pathname,id]);

  /**------------------------------------------------------------------------------------------------------------------------------------------------ */
  // HANDLER FUNCTIONS:
  const handleSetSavedTime = useCallback((time) => {
    setSavedTime(time);
  }, []);

  const setNextActiveStep = useCallback(() => {
    if (!meetingData) return;
    const stepsArray = meetingData?.steps;
    if (activeStepIndex !== stepsArray?.length - 1) {
      let stepsArray = meetingData?.steps;
      const activeStep = stepsArray[activeStepIndex];
      activeStep.savedTime = parseInt(savedTime);
      stepsArray[activeStepIndex] = activeStep;
      setMeetingData((prevState) => {
        return {
          ...prevState,
          steps: stepsArray,
        };
      });

      // STEP 2: SET ACTIVE STEP:
      const nextIndex = activeStepIndex + 1;
      setActiveStepIndex(nextIndex);
      setNextStepTrigger(nextStepTrigger + 1);
    } else {
      return;
    }
  }, [meetingData, activeStepIndex, savedTime]);

  const setPreviousActiveStep = useCallback(() => {
    if (!meetingData) return;
    // console.log("Saved Time", savedTime);
    const stepsArray = meetingData?.steps;
    if (activeStepIndex !== 0) {
      let stepsArray = meetingData?.steps;
      const activeStep = stepsArray[activeStepIndex];
      activeStep.savedTime = parseInt(savedTime);
      stepsArray[activeStepIndex] = activeStep;
      setMeetingData((prevState) => {
        return {
          ...prevState,
          steps: stepsArray,
        };
      });
      //STEP@: SET ACTIVE STEP:
      const previousIndex = activeStepIndex - 1;
      setActiveStepIndex(previousIndex);
      setPreviousStepTrigger(previousStepTrigger + 1);
    }
  }, [meetingData, activeStepIndex, savedTime]);

  return (
    <ErrorBoundary>
      <StepCounterContext.Provider
        value={{
          // COUNT DOWN TIMER STATES:
          meetingData,
          activeStepIndex,
          savedTime,
          negativeTimes,
          nextStepTrigger,
          previousStepTrigger,
          stepDelay,

          loading,
          setNextStepTrigger,
          setPreviousStepTrigger,
          setNegativeTimes,
          setActiveStepIndex,
          setMeetingData,
          setSavedTime,
          handleSetSavedTime,
          setNextActiveStep,
          setPreviousActiveStep,
          setStepDelay,
          setSelectedStep,
          selectedStep,
        }}
      >
        {children}
      </StepCounterContext.Provider>
    </ErrorBoundary>
  );
};
